export default {
  contextHeader: {
    notes: 'Context header explaining where in app there is an empty state',
    message: 'Empty in {{context}}',
  },
  error: {
    heading: {
      notes: 'Error state header',
      message: 'Not available',
    },
    text: {
      notes: 'Error text description',
      message: 'Please try again later',
    },
    notes: 'Text in empty component when an error occurred',
    message: 'Uh-oh, we ran into a problem. Please try again.',
  },
  warning: {
    notes: 'Text in empty component when a warning occurred',
    message: 'Uh-oh, we ran into a problem. Please try again.',
  },
  info: {
    notes: 'Text in empty component for information message',
    message: 'Information message',
  },
  noContent: {
    notes: 'Text in empty component when no content exists',
    message: 'No content to show, please modify your selection.',
  },
  noData: {
    notes: 'Text in empty component when no data exists',
    message: 'No data to show, please modify your selection.',
  },
  noDataChart: {
    notes: 'Text in empty component when no data exists for chart',
    message: 'No data to show, please modify your selection.',
  },
  noPermit: {
    notes: 'Text in empty component when the user lacks the required permit',
    message: 'The content is not accessible.',
  },
  invalidSelection: {
    notes: 'Text in empty component when user made an invalid selection',
    message: 'Invalid selection, please modify your selection.',
  },
  actions: {
    refreshPage: {
      notes: 'Label for action to refresh page',
      message: 'Refresh page',
    },
    tryAgain: {
      notes: 'Label for action to try again',
      message: 'Try again',
    },
  },
};
